import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class GeocodingTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var geocodingTool = this;
		setTimeout(function(){
			geocodingTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var geocodingTool = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookup',
					style: 'margin-left: 5px;',
					textstyle: 'width: 300px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:globe-wire', ' Geo-code')
					], 
					listeners: {
						click: function() {
							actionGeoCode();
						}
					}
				},
				{
					tag: 'vaadin-button',						
					theme: 'primary',												
					'class': 'spacer-toolbar-item',
					style: 'float: right; margin-top: 37px;',
					children:[
						ElementUtil.makeIcon('vaadin:upload', ' Bulk Upload')
					],
					listeners: {
						click: function() {
							actionUpload();
						}
					}
				}
				
			]
		});		
		
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [							
				{						
					path: 'field',
					header: 'Field',
					width: '7em'
				},	
				{						
					path: 'value',
					header: 'Value',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				}
			}
		});	
				
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'geocodingTool',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		geocodingTool.append(flexLayout);	
		
		
		var actionGeoCode = function() {
			var location = ElementUtil.query(toolbar, 'locationLookup').getValue();
			
			if (location === '') {
				window.DL.MessageUtil.showOkMessage('Location Required');
			} else {			
				var loadMask = grid.showLoading();
				RoutingService.getRoutingToolsService().geocode({
					rawLocation: location
				}).then(function(results) {
					loadMask.remove();

					var keyValue = [];
					results.forEach(function(result) {
						keyValue.push({
							field: 'Address 1',
							value: result.address1					
						});
						keyValue.push({
							field: 'Address 2',
							value: result.address2				
						});
						keyValue.push({
							field: 'City',
							value: result.city					
						});
						keyValue.push({
							field: 'State',
							value: result.state					
						});
						keyValue.push({
							field: 'Country',
							value: result.country					
						});
						keyValue.push({
							field: 'Postal Code',
							value: result.zip					
						});
						keyValue.push({
							field: 'Latitude',
							value: result.latitude					
						});
						keyValue.push({
							field: 'Longitude',
							value: result.longitude					
						});
						keyValue.push({
							field: 'Resolution Level',
							value: result.geoCodingResolutionLevel					
						});
						keyValue.push({
							field: 'Error Codes',
							value: result.errorCodes ? result.errorCodes.join(', ') : ''
						});

					});

					grid.items = keyValue;
				});
			
			}
		};
		
		var actionUpload = function() {
			
			var uploadWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Bulk Upload',
				icon: 'vaadin:upload',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var primaryToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'div',
									innerHTML: 'Format: Text - one location per line'									
								},
								{
									tag: 'vaadin-button',			
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:upload', ' Upload')
									], 
									listeners: {
										click: function() {
											actionShowUploadForm();
										}
									}
								},	
								{
									tag: 'hr'
								}
							]

						});
						
						var outputGrid = ElementUtil.create({
							tag: 'dl-backgroundoutput-grid',
							category: 'GEOCODE',
							slot: 'primary'							
						});
						
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								outputGrid,
								primaryToolbar
							]
						});
						uploadWin.addToContentElement(flexLayout);
						
						var actionShowUploadForm = function() {
							
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Geocoding File',
								icon: 'vaadin:upload',
								width: 450,
								height: 315,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A geo-coding import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-text-field',
													label: 'Note',
													name: 'note',
													maxLength: 255
												},
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/service/routing-tools/geo-code/upload',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
															var data = uploadFormPanel.getData();
															event.detail.formData.append('note', data.note);															
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'File will be processed in the background.', {									
																	theme: 'success'
																});															
																outputGrid.refresh();
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}


							});		
							
						};
						
					}
				}
			});
			
			
		};

	}
	
}
customElements.define('dl-geocoding-tool', GeocodingTool);


